import { ConnectionPoint, ConnectionPointType } from '../../models';

const wideDbTypes: ConnectionPointType[] = [
    ConnectionPointType.WideDatabase,
    ConnectionPointType.WideDatabaseNpgsql,
];

export const isWideDb: (cp: ConnectionPoint) => boolean = (cp: ConnectionPoint) => {
    return (cp && wideDbTypes.indexOf(cp.type) >= 0);
};